import { FC } from "react";

import styles from "./VolumeSharePreview.module.scss";
import { NoWidgetDataStub } from "../../../WidgetTile/components";

export const VolumeSharePreview: FC<Widget.PreviewProps> = ({
  views,
  view,
}) => {
  if (!views.length)
    return (
      <div className={styles.widgetPreview}>
        <NoWidgetDataStub />
      </div>
    );

  return (
    <div className={styles.widgetPreview}>
      <div className={styles.chartWrapper}>{view?.chart}</div>
    </div>
  );
};
